<template>


    <Transition name="modal-fade">
      <div v-if="isdisplay" class="cf-overlay" @click.self="close">
        <Transition name="modal-slide">
          <div v-if="isdisplay" class="cf-dialog cf-dialog--xxl">

                <!-- Header -->
                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-funds-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">{{ titlemodal }}</h4>
                            <p class="cf-modal-head__sub">Suivi du chiffre d'affaires</p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                </div>

                <!-- Body -->
                <div class="cf-dialog-body">



                    <div class="box  overflow-hidden">
                        <div class="box-header justify-between " style="display: block">



                            <div class="grid grid-cols-12  gap-x-6">

                                <div class="xl:col-span-6 mt-3  col-span-12">
                                    <label  class="form-label">Mois</label>

                                    <select @change="loadupdate" v-model="mmois" class="form-control ti-select w-full" aria-label="Page Size" title="Affichage">
                                        <option value="01">Janvier</option>
                                        <option value="02">Février</option>
                                        <option value="03">Mars</option>
                                        <option value="04">Avril</option>
                                        <option value="05">Mai</option>
                                        <option value="06">Juin</option>
                                        <option value="07">Juillet</option>
                                        <option value="08">Août</option>
                                        <option value="09">Septembre</option>
                                        <option value="10">Octobre</option>
                                        <option value="11">Novembre</option>
                                        <option value="12">Décembre</option>

                                    </select>


                                </div>

                                <div class="xl:col-span-6 mt-3  col-span-12">
                                    <label  class="form-label">Année</label>

                                    <select  @change="loadupdate" v-model="manne" class="form-control ti-select w-full">
                                        <option v-for="(anne,index) of listedesannees" :key="index" :value="anne">{{anne}}</option>

                                    </select>


                                </div>

                                <div class="xl:col-span-12 mt-3 mb-3 col-span-12">
                                    <label  class="form-label">Affichage en</label>

                                    <select v-model="typaffiche" class="form-control ti-select w-full">
                                        <option value="Graph">Graph</option>
                                        <option value="Tableau">Tableau</option>
                                    </select>


                                </div>



                            </div>



                        </div>



                        <div v-show="typaffiche==='Tableau'" class="box-body !p-0 mybodyheight300px">
                            <div class="table-responsive">

                                <div class="flex flex-col h-screen">
                                    <div class="flex-grow overflow-auto">

                                   <table class="relative w-full border table mytable table-hover whitespace-nowrap min-w-full">
                                            <thead>
                                            <tr>
                                                <th scope="col" class="th text-start">JOUR</th>
                                                <th scope="col" class="th text-start">CA</th>

                                            </tr>
                                            </thead>
                                            <tbody>

                                            <template v-if="filterdatatable.length">

                                                <tr  class="border-t hover:bg-gray-200 dark:hover:bg-light" v-for="(datavalue,index) in filterdatatable" :key="index">

                                                    <td  data-label="JOUR  : "   >{{ datavalue.mmonth }}</td>
                                                    <td class="text-center" data-label="CA  : "   >{{ formatMoney(datavalue.mmontant)  }}</td>

                                                </tr>

                                            </template>

                                            <template v-else>
                                                <tr>
                                                    <td colspan="2">
                                                        <div class="empty-state">
                                                            <div class="empty-state__icon"><i class="ri-funds-line"></i></div>
                                                            <p class="empty-state__title">Aucune donnée</p>
                                                            <p class="empty-state__sub">Aucun chiffre d'affaires trouvé pour cette période.</p>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </template>

                                            </tbody>
                                       <tfoot>
                                       <tr>
                                           <th scope="col" class="th text-start">TOTAL</th>
                                           <th scope="col" style="text-align: center" class="th text-start">{{formatMoney(mmontanttotal) }}</th>


                                       </tr>
                                       </tfoot>
                                        </table>


                                    </div>
                                </div>

                            </div>
                        </div>

                        <div v-show="typaffiche==='Tableau'" class="flex flex-col box-footer border-t-0 ">
                            <div class="flex items-center flex-wrap overflow-auto">
                                <div class="mb-2 sm:mb-0">

                                </div>
                                <div class="ms-auto">


                                    <nav v-if="pages.length > 1" class="pagination" aria-label="Page navigation">
                                        <button @click="page--" :disabled="page <= 1" class="page-btn page-btn--nav"><i class="ri-arrow-left-s-line"></i></button>
                                        <template v-for="(pageNumber, key) in displayedPages" :key="key">
                                            <span v-if="pageNumber === '...'" style="padding:0 4px;color:var(--cf-faint);font-size:13px;">…</span>
                                            <button v-else @click="page = pageNumber" :class="['page-btn', pageNumber === page ? 'page-btn--active' : 'page-btn--default']">{{ pageNumber }}</button>
                                        </template>
                                        <button @click="page++" :disabled="page >= pages.length" class="page-btn page-btn--nav"><i class="ri-arrow-right-s-line"></i></button>
                                    </nav>





                                </div>
                            </div>
                        </div>



                        <div v-show="typaffiche==='Graph'" class="box-body !p-0 mybodyheight500px">

                            <div class="xl:col-span-6 col-span-12">
                                <div class="box custom-box">
                                    <div class="box-header justify-between">
                                        <div class="box-title">
                                            -
                                        </div>

                                    </div>
                                    <div class="box-body">


                                        <div id="chart">
                                            <apexcharts ref="apexChart" type="line" height="350" :options="chartOptions3" :series="series3"></apexcharts>
                                        </div>



                                    </div>
                                    <div class="box-footer border-t-0 hidden">

                                    </div>
                                </div>
                            </div>



                        </div>


                    </div>





                </div>
                <!-- Footer -->
                <div class="cf-dialog-foot">
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                </div>

          </div>
        </Transition>
      </div>
    </Transition>




</template>

<script>

    import VueApexCharts from "vue3-apexcharts";


    const axios =require('axios');


    import {currencyFormatDE, currentMonth, currentYear, getYear2020, randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";

    export default {
        /* eslint-disable */
        name: "formsupp",

        watch: {
            searchword: function(newvalue,oldvalue){

                this.page=1

            },

            searchtrierletableau: function(newvalue,oldvalue){

                this.page=1

            },


        },
        computed:{

            displayedPages() {
                const start = Math.max(1, this.page - 5);
                const end = Math.min(this.pages.length, start + 9);

                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },
            filterdatatable(){

                let mvalue=this.datatable;

                //this.page=this.Defaultpage;
                this.perPage=this.DefaultperPage;

                let t=this

                t.mmontanttotal=0;

                mvalue.forEach(function ($line) {
                    t.mmontanttotal=parseFloat(t.mmontanttotal)+parseFloat($line.mmontant);
                })


                return this.paginate(mvalue) ;
            },
        },
        components: {
            apexcharts: VueApexCharts,

        },

        data() {
            return {
                isdisplay:false,
                titlemodal:"",
                mmontanttotal:0,

                mmois:currentMonth(),
                manne:currentYear(),
                listedesannees:[],
                typaffiche:'Graph',

                afichagetable:[],
                alldata:[],
                datatable:[],
                allgraphs:[],
                labels:[],
                dataset:[],


                series3: [

                    {
                        name: "Desktops",
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0]
                    },
                ]
                ,
                chartOptions3: {
                    chart: {
                        height: 350,
                        type: 'line',
                        zoom: {
                            enabled: true
                        }
                    },
                    title: {
                        text: "Évolution du chiffre d'affaires par jour au cours du mois",
                        align: 'left'
                    },
                    xaxis: {
                        categories: ['-', '-', '-', '-', '-', '-', '-', '-', '-'],
                    },
                    colors: ['#00E396'] // Couleurs initiales
                },




                posts : [''],
                page: 1,
                // perPage: 100,
                perPage: 50,
                Defaultpage: 1,
                DefaultperPage: 50,
                pages: [],
            };
        },
        methods: {


            async loadupdate(){


                        this.$store.dispatch('lancerchargement',true)

                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egldsds74gescom8571714dfe/rapport/gescom/'+this.manne+'/'+this.mmois+'/'+this.$store.state.appsociete+'/suivie_ca_0287845854/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)


                        if(res.data.success){


                            t.datatable=[];
                            t.allgraphs=[];
                            t.dataset=[];
                            t.labels=[];
                            t.allgraphs=res.data.allgraphs;
                            t.labels=res.data.l;
                            t.datatable=res.data.pp;


                            t.chartOptions3.xaxis.categories=res.data.xaxis;
                            t.chartOptions3.colors=res.data.colors;

                            t.series3=res.data.allgraphs;

                            t.$refs.apexChart.updateOptions(t.chartOptions3);

                        }
                        else{
                            t.datatable=[];
                            t.dataset=[];
                            t.allgraphs=[];
                            t.labels=[];
                        }


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })




            },


            async load(){


                        this.$store.dispatch('lancerchargement',true)

                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egldsds74gescom8571714dfe/rapport/gescom/'+this.manne+'/'+this.mmois+'/'+this.$store.state.appsociete+'/suivie_ca_0287845854/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)


                        if(res.data.success){


                            t.datatable=[];
                            t.allgraphs=[];
                            t.dataset=[];
                            t.labels=[];
                            t.allgraphs=res.data.allgraphs;
                            t.labels=res.data.l;
                            t.datatable=res.data.pp;


                            t.chartOptions3.xaxis.categories=res.data.xaxis;
                            t.chartOptions3.colors=res.data.colors;

                            t.series3=res.data.allgraphs;



                            t.isdisplay=true;

                        }
                        else{
                            t.datatable=[];
                            t.dataset=[];
                            t.allgraphs=[];
                            t.labels=[];
                            t.isdisplay=true;
                        }


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })




            },

            close(){

                this.isdisplay=false;

                //this.$emit('closed');

            },

            show(titlemodal){


                this.messagesucces="";
                this.messageerror="";
                this.titlemodal="Évolution du chiffre d'affaires par jour au cours du mois"

                this.datatable=[];

                this.mmois=currentMonth();
                    this.manne=currentYear();
                    this.listedesannees=getYear2020();

                this.load()



            },


            formatMoney(num) {

                return  currencyFormatDE(num)
            },



            //****************************************************************//

            setPages (posts) {
                this.pages=[];
                // let numberOfPages = Math.ceil(this.datatable.length / this.perPage);
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {

                    this.pages.push(index);
                }
            },
            paginate (posts) {

                this.setPages(posts)
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);

                let $res=posts.slice(from, to)

                if ($res.length>0){
                    return $res;
                }else{

                    return posts;
                }

                // return  posts.slice(from, to);
            }



        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:94vh; overflow:hidden; }
.cf-dialog--xxl { max-width:1200px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.th { position:sticky; top:0; z-index:2; padding:0.7rem 1rem; font-weight:600; font-size:0.75rem; color:var(--cf-ink); background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); white-space:nowrap; letter-spacing:0.02em; text-align:left; }

/* Empty state */
.empty-state { padding:2.5rem 1.5rem; text-align:center; }
.empty-state__icon { font-size:40px; color:var(--cf-faint); margin-bottom:14px; }
.empty-state__title { font-size:0.95rem; font-weight:600; color:var(--cf-ink-strong); margin:0 0 6px; }
.empty-state__sub { font-size:0.82rem; color:var(--cf-muted); margin:0; }

/* ===== PAGINATION ===== */
.pagination { display:flex; align-items:center; gap:4px; }
.page-btn { min-width:30px; height:30px; padding:0 8px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm);
    background:#fff; color:var(--cf-ink); font-size:0.78rem; font-weight:600; cursor:pointer; transition:all 0.15s; }
.page-btn:hover:not(:disabled) { border-color:rgb(var(--primary) / 0.35); background:var(--cf-surface); }
.page-btn:disabled { opacity:0.5; cursor:not-allowed; }
.page-btn--active { background:rgb(var(--primary)); border-color:rgb(var(--primary)); color:#fff; }
.page-btn--nav { width:34px; display:inline-flex; align-items:center; justify-content:center; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

    .table td {
        cursor: pointer;
    }

    .h-screen{

        height: 300px!important;

    }

    .mybodyheight200px{
        height: 200px;
    }

    .mybodyheight300px{
        height: 300px;
    }

    .mybodyheight400px{
        height: 400px;
    }

    .mybodyheight500px{
        height: 500px;
    }

    @media screen and (max-width: 768px) {

        .cf-dialog--xxl { max-width:100%; }


        .h-screen,.mybodyheight200px,.mybodyheight300px, .mybodyheight400px,.mybodyheight500px{
            height: 100%!important;
        }


    }

</style>
